import React, { FC, ReactElement } from 'react';
import styles from './TransparentButton.module.scss';
import { Button, Link } from '@mui/material';

export interface TransparentButtonProps {
  onClick: () => void;
  icon?: ReactElement;
  text: string;
}

const TransparentButton: FC<TransparentButtonProps> = ({ onClick, icon, text }) => {
  return (
    <Button className={styles.button} variant='outlined' size='small' onClick={onClick}>
      {icon && icon}
      {text}
    </Button>
  )
};

export default TransparentButton;
